export type UniversityProbationType =
  | "ACADEMIC"
  | "ADMINISTRATIVE"
  | "PLAYING_ABILITY_TEST"
  | "TOURNAMENT_REQUIREMENTS"
  | "PGM_PROGRESS"
  | "OTHER";

export const PROBATION_TYPE_OPTIONS: Array<{ value: UniversityProbationType; label: string }> = [
  { value: "ACADEMIC", label: "Academic" },
  { value: "ADMINISTRATIVE", label: "Administrative" },
  { value: "PLAYING_ABILITY_TEST", label: "Playing Ability Test" },
  { value: "TOURNAMENT_REQUIREMENTS", label: "Tournament Requirements" },
  { value: "PGM_PROGRESS", label: "PGM Progress" },
  { value: "OTHER", label: "Other" }
];

const PROBATION_TYPE_LABELS = Object.fromEntries(
  PROBATION_TYPE_OPTIONS.map(({ value, label }) => [value, label])
) as Record<UniversityProbationType, string>;

export function getProbationTypeLabel(probationType?: UniversityProbationType | null): string {
  if (!probationType) return "—";
  return PROBATION_TYPE_LABELS[probationType] ?? probationType;
}
